import React, { useRef, useEffect } from "react";
import "./PrintingTech.css";

const data = [
  {
    title: "Impresión UV",
    text: "Impresión con luz UV que seca rápido, permite materiales grandes, flexibles o rígidos y resiste sol y lluvia.",
    video: "/videos/uv.mp4",
    image: "/images/miniaturas/uv-preview.webp",
    gradient: "linear-gradient(135deg, #5c0b16, #9d2432)",
    rotation: "-5deg",
  },
  {
    title: "Impresión Látex",
    text: "La impresión Látex ofrece colores vibrantes y duraderos, resistentes al agua y rasguños, con duración hasta tres años sin laminado.",
    video: "/videos/latex.mp4",
    image: "/images/miniaturas/latex-preview.webp",
    gradient: "linear-gradient(135deg, #b12762, #7728a0)",
    rotation: "3deg",
  },
  {
    title: "Sublimación en tela",
    text: "Esta tecnología ofrece colores intensos y detalles nítidos, aplicable en más de 100 tipos de telas, lonas y viniles para moda, decoración y branding.",
    video: "/videos/sublimacion.mp4",
    image: "/images/miniaturas/sublimacion-preview.webp",
    gradient: "linear-gradient(135deg, #ff6a00, #ff3c00)",
    rotation: "5deg",
  },
  {
    title: "Offset Digital en Pliego",
    text: "Permite crear imágenes de alta calidad usando tintas especiales y transferencia térmica, lo que hace que las impresiones salgan secas y listas para su acabado.Capaz de imprimir hasta 4, 600 hojas por hora, puede personalizar texto e imágenes.",
    video: "/videos/pliego.mp4",
    image: "/images/miniaturas/pliego-preview.webp",
    gradient: "linear-gradient(135deg, #b08968, #d4a373)",
    rotation: "-4deg",
  },
  {
    title: "Offset Digital en Rollo",
    text: "Esta impresión destaca por su calidad y eficiencia en etiquetas y mangas termoencogibles.",
    video: "/videos/rollo.mp4",
    image: "/images/miniaturas/rollo-preview.webp",
    gradient: "linear-gradient(135deg, #00bcd4, #2196f3)",
    rotation: "4deg",
  },
];

const PrintingTech = () => {
  return (
    <div id="tecnologias">
      <div className="title-tech">
        <img src="../images/logo/MotiPuntos.svg" alt="decorativo" />
        <span>
          The way the printout{" "}
          <span className="span-special-sub-banner">should've </span> been
          printed from the very beginning.
        </span>
      </div>
      <section className="printing-tech">
        {data.map((item, i) => (
          <Card key={i} {...item} index={i} />
        ))}
      </section>
    </div>
  );
};

const Card = ({ title, text, video, image, gradient, rotation, index }) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = React.useState(false);

  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  useEffect(() => {
    if (!isMobile || !videoRef.current) return;

    const vid = videoRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const playPromise = vid.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => { });
            }
            setIsPlaying(true);
          } else {
            vid.pause();
            vid.currentTime = 0;
            setIsPlaying(false);
          }
        });
      },
      { threshold: 0.01 } 
    );

    observer.observe(vid);
    return () => observer.disconnect();
  }, [isMobile]);

  const handleHover = (play) => {
    if (isMobile) return; 
    const vid = videoRef.current;
    if (!vid) return;

    if (play) {
      const playPromise = vid.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => { });
      }
      setIsPlaying(true);
    } else {
      vid.pause();
      vid.currentTime = 0;
      setIsPlaying(false);
    }
  };

  const positionClass = index % 2 === 0 ? "bottom-text" : "top-text";

  return (
    <div
      className={`card ${positionClass}`}
      style={{ background: gradient }}
      onMouseEnter={() => handleHover(true)}
      onMouseLeave={() => handleHover(false)}
    >
      <div className="video-wrapper">
        <img
          src={image}
          alt={title}
          className={`preview-image ${isPlaying ? "hidden" : ""}`}
          style={{ transform: `rotate(${rotation})` }}
        />

        <video
          ref={videoRef}
          src={video}
          muted
          loop
          playsInline
          preload="metadata"
          className={`preview-video ${isPlaying ? "visible" : ""}`}
          style={{ transform: `rotate(${rotation})` }}
        />
      </div>

      <div className="text-content">
        <h3>{title}</h3>
        <p>{text}</p>
      </div>
    </div>
  );
};

export default PrintingTech;
